/* @flow */
import type { Action } from "../action";
import type { StockCategory } from "../CommonTypes";

export type State = Array<StockCategory>;

function stockCategories(state: State = [], action: Action): State {
  switch (action.type) {
    case "RECEIVE_STOCK_ASSETS":
      return Object.keys(action.payload || {});
    default:
      return state;
  }
}

export default stockCategories;



// WEBPACK FOOTER //
// ./src/redux/reducer/stockCategories.js